class PrintPackedOrdersController {
    /*@ngInject*/
    constructor($state, $stateParams, $translate, OrderPackingService) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$translate = $translate;
        this.OrderPackingService = OrderPackingService;
        this.model = {
            results: {}
        }
        this.headers = [
            "Delivery Date",
            "Order No",
            "Order Type",
            "Tracking Id",
            "Amount",
            "Denomination",
            "OrderTotal",
            "Route",
            "To Location",
            "Address"
        ];
        this.accounts = [
            {
                label: 'Regular',
                value: 'regularShipmentData'
            },
            {
                label: 'Emergency',
                value: 'emergencyShipmentData'
            }
        ];
        this.users = [
            {
                label: 'Pack',
                value: 'pack'
            },
            {
                label: 'Pack',
                value: 'pack'
            },
            {
                label: 'Receiver',
                value: 'receiver'
            },
        ]
    }

    $onInit() {
        if (window.opener && window.opener.w && window.opener.w.printData) {
            this.loading = true;
            const data = window.opener.w.printData;
            const { branchId, vaultDate, sortColumn, reverseSort, orderType, route, searchText, fundingSourceId, currencySymbol, customerId } = data;
            this.vaultDate = vaultDate;
            this.currencySymbol = currencySymbol || '$';

            this.OrderPackingService.printPackedShipments(branchId, vaultDate, sortColumn, !reverseSort, orderType, route, searchText, fundingSourceId, currencySymbol, customerId)
                .then((data) => {
                    this.model.results = data.results;
                    if (data.currencySymbol) this.currencySymbol = data.currencySymbol;
                    this.regularOrdersTotal = this.model.results.regularShipmentData.reduce((sum, row) => sum + Number(String(row[4]).replace(/[^0-9.]/g, "")), 0);
                    this.emergencyOrdersTotal = this.model.results.emergencyShipmentData.reduce((sum, row) => sum + Number(String(row[4]).replace(/[^0-9.]/g, "")), 0);
                    setTimeout(() => {
                        window.print();
                    }, 1000)
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    this.loading = false;
                })
        }
    }

    shouldRemoveBorder(currentIndex, stat) {
        if (currentIndex === 0) return false;

        const currentRow = this.model.results[stat][currentIndex];
        const prevRow = this.model.results[stat][currentIndex - 1];

        const currentOrder = currentRow[1];
        const prevOrder = prevRow[1];

        const currentTracking = currentRow[3];
        const currentRoute = currentRow[7];

        if (currentOrder === prevOrder && !currentTracking && !currentRoute) {
            return true;
        }

        return false;
    };
}

export default PrintPackedOrdersController;



// WEBPACK FOOTER //
// ./client/app/components/order_packing/print_packed_orders/print_packed_orders.controller.js